import { Table } from '@shinetools/lumen-react'
import { ReactElement, ReactNode } from 'react'

import * as Styled from './styles'

interface EmptyStateTableProps {
  children: ReactNode
  header: ReactNode
  minWidth: `${number}px`
}

export const EmptyStateTable = ({ children, header, minWidth }: EmptyStateTableProps): ReactElement => (
  <Styled.EmptyStateFrame>
    <Table compact>
      <Styled.HeaderScroll>
        <Styled.HeaderTable $minWidth={minWidth}>{header}</Styled.HeaderTable>
      </Styled.HeaderScroll>
    </Table>
    <Styled.EmptyStateBody>{children}</Styled.EmptyStateBody>
  </Styled.EmptyStateFrame>
)
